// Segue-Editor im Sendeplan: vorheriges, dieses und nächstes Element als Wellenform-Spuren auf einer Zeitachse.
// Block ziehen = Einsatz (Segue des vorigen) verschieben, Lautstärkepunkte setzen, vorhören, speichern.
// Gilt nur für diese Ausstrahlung; der Sendeplan bleibt darüber sichtbar.

import { LaneEditor, defaultEnvelope, laneStarts, usePreview, useTransition } from "../../wave";
import { fmtMs } from "../../api";

export function SegueDrawer({ entryId, onClose, onSaved }: { entryId: string; onClose: () => void; onSaved: () => void }) {
  const t = useTransition(entryId);
  const { play, stop, playhead } = usePreview(t.lanes);
  const l = t.lanes;
  const starts = l ? laneStarts(l) : {};
  const fadeOutPrev = () => {
    if (!l?.prev) return;
    const m = l.prev.marks;
    const seg = m.start_next ?? m.cue_out;
    t.setLanes({ ...l, prev: { ...l.prev, marks: { ...m, level_points: [{ ms: Math.max(m.cue_in ?? 0, seg - 500), db: 0 }, { ms: seg + 2500, db: -40 }] } } });
  };
  const rampIn = () => {
    if (!l) return;
    const m = l.cur.marks;
    const ci = m.cue_in ?? 0;
    t.setLanes({ ...l, cur: { ...l.cur, marks: { ...m, level_points: [{ ms: ci, db: -30 }, { ms: ci + 1500, db: 0 }, ...(m.level_points ?? defaultEnvelope(m)).filter((p: any) => p.ms > ci + 1500)] } } });
  };
  return (
    <div style={{ position: "fixed", left: 0, right: 0, bottom: 0, height: "48vh", zIndex: 70, background: "#0c1411", color: "#e6efe9", boxShadow: "0 -8px 30px rgba(0,0,0,.35)", padding: "10px 16px", overflow: "auto" }}>
      <div className="row wrap" style={{ marginBottom: 8, gap: 8 }}>
        <b style={{ fontSize: 16 }}>Übergang bearbeiten</b>
        {l && <span className="small" style={{ opacity: 0.7 }}>{l.cur.media ? `${l.cur.media.artist ? `${l.cur.media.artist} – ` : ""}${l.cur.media.title}` : l.cur.label}</span>}
        <span className="spacer" />
        {!!l?.cur.overlays?.length && <button className="btn small" onClick={() => play(starts.cur ?? 0, Math.max(16, ((l.cur.marks.intro ?? 16000) - (l.cur.marks.cue_in ?? 0)) / 1000 + 2))}>▶ Rampe mit Dropper</button>}
        {l?.prev && <button className="btn small" onClick={() => play(Math.max(0, (starts.cur ?? 0) - 5000))}>▶ Übergang davor</button>}
        {l?.next && <button className="btn small" onClick={() => play(Math.max(0, (starts.next ?? 0) - 5000))}>▶ Übergang danach</button>}
        {playhead != null && <button className="btn small" onClick={stop}>■ Stopp</button>}
        <button className="btn small" disabled={!l?.prev} onClick={fadeOutPrev} title="Vorigen Titel ab dem Einsatz in 3 s ausblenden">Ausblenden davor</button>
        <button className="btn small" onClick={rampIn} title="Dieses Element in 1,5 s einblenden">Einblenden</button>
        <button className="btn small" disabled={!t.canUndo} onClick={t.undo}>↶ Rückgängig</button>
        <button className="btn small" onClick={t.reset}>Zurücksetzen</button>
        <button className="btn small primary" disabled={!t.dirty} onClick={async () => { await t.save(); onSaved(); }}>Speichern</button>
        <button className="btn small" onClick={() => { stop(); onClose(); }}>✕</button>
      </div>
      {!l ? <div>Lade …</div> : (
        <>
          {l.cur.overlayWarnings?.map((text) => <p key={text} style={{ color: "#ffe08a" }}>{text}</p>)}
          <LaneEditor lanes={l} onChange={t.setLanes} playhead={playhead} />
          <div className="row small" style={{ marginTop: 6, gap: 14, opacity: 0.8 }}>
            {l.prev && <span>Einsatz nach {fmtMs((l.prev.marks.start_next ?? l.prev.marks.cue_out) - (l.prev.marks.cue_in ?? 0))} des vorigen Titels</span>}
            {l.next && <span>Nächster Einsatz nach {fmtMs((l.cur.marks.start_next ?? l.cur.marks.cue_out ?? 0) - (l.cur.marks.cue_in ?? 0))}</span>}
            {t.dirty && <span style={{ color: "#ffe08a" }}>ungespeichert</span>}
          </div>
        </>
      )}
    </div>
  );
}
